import { ComboBoxDropDown } from "@etframework/ui.components";
import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Enums from "../../types/enums";

export const AgencyCombobox = forwardRef(
  ({ id, initialTaskType, ...rest }, ref) => {
    const { t } = useTranslation(["CreateTaskModal"]);
    const componentRef = useRef();

    const [hasTaskTaxReturnInfo, setHasTaskTaxReturnInfo] = useState(
      initialTaskType?.Type === Enums.TaskType.TaxReturn
    );

    useImperativeHandle(
      ref,
      () => ({
        ...componentRef.current,
        setValue: (...args) => componentRef.current?.setValue(...args),
        setHasTaskTaxReturnInfo,
      }),
      [componentRef]
    );

    if (!hasTaskTaxReturnInfo) return;

    return (
      <ComboBoxDropDown
        allowFiltering
        id={id}
        ref={componentRef}
        allowObjectBinding
        maxLength={"100"}
        allowCustom
        name="Agency"
        fields={{ text: "Name", value: "Id" }}
        htmlFor="agency"
        label={t("AgencyLabel")}
        {...rest}
      />
    );
  }
);
